module.exports = "https://static.wagwalking.com/_next/static/images/vet-assistant-724c7d917b4a3b0fab35f61fed95551c.png";